<template>
    <div class="detailUsersAdmin">
        <div v-if="loading" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
                indeterminate></v-progress-circular>
        </div>

        <div v-else class="col-md-12">
            <v-form ref="form" lazy-validation class="col-sm-12 col-md-12">
                <div class="custom-row">
                    <div class="col-sm-12 col-md-5">

                        <v-text-field :label="'*'+$t('usersAdmin.label.firstName.title')" :placeholder="$t('usersAdmin.label.firstName.text')"
                            required :counter="50" :maxlength="50" :rules="firstNameRules" color=secondary v-model="formData.firstName"></v-text-field>

                        <v-text-field :label="'*'+$t('usersAdmin.label.lastName.title')" :placeholder="$t('usersAdmin.label.lastName.text')"
                            required :counter="50" :maxlength="50" :rules="lastNameRules" color=secondary v-model="formData.lastName"></v-text-field>

                        <v-select :label="'*'+$t('label.typeIdentification.title')" :placeholder="$t('label.typeIdentification.text')"
                            required :items="typeIdentification" item-text="identificationType" item-value="identificationId" color="secondary" 
                            :rules="typeIdentificationRules" v-model="formData.identificationId"></v-select>

                        <v-text-field :label="'*'+$t('label.email.title')" :placeholder="$t('label.email.text')"  
                            required :counter="200" :maxlength="200" :rules="emailRules" color=secondary v-model="formData.emailAddress"></v-text-field>

                        <v-select :label="'*'+$t('usersAdmin.label.gender.title')" :placeholder="$t('usersAdmin.label.gender.text')"  
                            required :items="affiliatedGender" item-text="gernderName" item-value="genderId" :rules="genderRules" color="secondary" 
                            v-model="formData.genderId"></v-select>
                    </div>
                    <div class="col-sm-12 col-md-5">

                        <v-text-field :label="$t('usersAdmin.label.middleName.title')" :placeholder="$t('usersAdmin.label.middleName.text')"
                            :counter="50" :maxlength="50" color=secondary v-model="formData.middleName"></v-text-field>

                        <v-text-field :label="$t('usersAdmin.label.secondLastName.title')" :placeholder="$t('usersAdmin.label.secondLastName.text')"
                            :counter="50" :maxlength="50" color=secondary v-model="formData.secondLastName"></v-text-field>

                        <v-text-field :label="'*'+$t('label.numIdentification.title')" :placeholder="$t('label.numIdentification.text')" 
                            required :rules="identificationNumberRules" @input="formatIdentificationNumber" color="secondary"
                            v-model="formData.identificationNumber" @keydown="handleKeyDown" inputmode="numeric" :counter="19" :maxlength="19"></v-text-field>

                        <v-select :label="'*'+$t('usersAdmin.label.role.title')" :placeholder="$t('usersAdmin.label.role.text')" 
                            required :items="updatedTypeRol" item-text="nameRole" item-value="roleId" color="secondary"
                            :disabled="!disableUserT || (formData.roleId == 1 && !isSuperAdmin)" :rules="typeRolRules" v-model="formData.roleId"></v-select>

                        <v-row>
                            <v-col cols="4" md="3" sm="3">
                                <v-select :label="'*'+$t('label.indicative.title')" required :items="listGender"
                                    item-text="countryPhoneCode" item-value="countryPhoneCodeId" color="secondary"
                                    v-model="formData.countryPhoneCodeId" :rules="CountryPhoneCodeRules">
                                </v-select>
                            </v-col>

                            <v-col cols="8" md="9" sm="9">
                                <v-text-field :label="'*'+$t('label.phone.title')" :placeholder="$t('label.phone.text')" required
                                    :rules="phoneRules" color="secondary" v-model="formData.cellPhoneNumber" @keydown="handleKeyDown"
                                    inputmode="numeric" pattern="[0-9]{15}" :counter="15" :maxlength="15">
                                </v-text-field>
                            </v-col>
                        </v-row>

                    </div>
                </div>
            </v-form>

        </div>

        <v-tooltip left>

            <template v-slot:activator="{ on, attrs }">

                <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on" @click="submitForm">
                    <v-icon dark>mdi-content-save</v-icon>
                </v-btn>

            </template>

            <span>{{ $t('button.update') }}</span>

        </v-tooltip>
    </div>
</template>



<script>

import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";

import {
    USERSADMIN_M,
    ACTION_PUT_UPDATE_USERSADMIN,
    ACTION_GET_USERSADMIN_LIST_TYPE_DOCUMENT,
    GET_USERADMIN_LIST_TYPE_DOCUMENT,
    ACTION_GET_USERSADMIN_LIST_TYPE_ROL,
    GET_USERADMIN_LIST_TYPE_ROL,
    ACTION_GET_USERSADMIN_ID,
    GET_USER_ADMIN_ID,
    GET_STATE_LOADING,
    ACTION_GET_AFFILIATEDUSERS_LIST_GENDER,
    GET_AFFILIATEDUSERS_LIST_GENDER,
} from "@/views/users_admin/store/types/types.js";

import {
    PRODUCTS_M,
    ACTION_GET_LIST_COUNTRY,
    GET_LIST_COUNTRY
} from "@/views/products/store/types/types.js";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export default {

    components: {

    },
    name: "detailUsersAdmin",
    props: {
        usersAdmin: {
            required: true
        },
        disableUserT: {
            required: true
        }
    },

    data() {
        return {
            formData: {
                userId: '',
                firstName: '',
                middleName: '',
                lastName: '',
                isFirstUserCompany: false,
                companyId: '',
                secondLastName: '',
                identificationType: '',
                emailAddress: '',
                genderId: '',
                gernderName: '',
                identificationId: '',
                cellPhoneNumber: '',
                roleId: '',
                nameRole: '',
                identificationNumber: '',
                countryPhoneCodeId: '',
                userDetailId: '',
            },

            roleId: sessionStorage.getItem("roleId"),
            firstNameRules: [
                v => !!v || this.$t('usersAdmin.label.firstName.required')
            ],
            lastNameRules: [
                v => !!v || this.$t('usersAdmin.label.lastName.required')
            ],
            typeIdentificationRules: [
                v => !!v || this.$t('label.typeIdentification.required')
            ],
            emailRules: [
                v => !!v || this.$t('label.email.required'),
                v => emailRegex.test(v) || this.$t('label.email.invalid')
            ],
            typeRolRules: [
                v => !!v || this.$t('usersAdmin.label.role.required')
            ],
            genderRules: [
                v => !!v || this.$t('usersAdmin.label.gender.required')
            ],
            identificationNumberRules: [
                v => !!v || this.$t('label.numIdentification.required')
            ],
            CountryPhoneCodeRules: [
                v => !!v || this.$t('label.indicative.required')
            ],
            phoneRules: [
                v => !!v || this.$t('label.phone.required'),
                v => (v && v.length >= 7 && v.length <= 15) || this.$t('label.phone.maxLength')
            ],

            showErrorMessages: false,
            usersAdminUpdate: null,
        };
    },

    async mounted() {
    try {
        if (this.usersAdmin) {
            this.usersAdminsUpdate = await this.getActionUsersAdminId(this.usersAdmin);
            this.updateUserAdmin();
        }
        await Promise.all([
            this.getActionTypeIdentification(),
            this.getActionTypeRol(),
            this.getActionListCountry(),
            this.getAffiliatedGender()
        ]);
    } catch (error) {
        console.error("Error en mounted:", error);
    }
},

    computed: {
        ...mapGetters({
            loading: [`${USERSADMIN_M}${GET_STATE_LOADING}`],
            typeIdentification: [`${USERSADMIN_M}${GET_USERADMIN_LIST_TYPE_DOCUMENT}`],
            typeRol: [`${USERSADMIN_M}${GET_USERADMIN_LIST_TYPE_ROL}`],
            affiliatedGender: [`${USERSADMIN_M}${GET_AFFILIATEDUSERS_LIST_GENDER}`],
            listGender: [`${PRODUCTS_M}${GET_LIST_COUNTRY}`],
            userAdminId: [`${USERSADMIN_M}${GET_USER_ADMIN_ID}`],

        }),

        isSuperAdmin() {
            return this.roleId === "1";
        },

        updatedTypeRol() {
            const roles = [...this.typeRol];
            // Verificar si el rolId actual está en la lista de roles
            if (this.formData.roleId && !roles.find(role => role.roleId === this.formData.roleId)) {
                // Agregar el rol correspondiente si no está en la lista
                roles.push({
                    nameRole: this.formData.nameRole,
                    roleId: this.formData.roleId
                });
            }
            return roles;
        },


    },

    watch: {
        usersAdmin: {
            immediate: true,
            handler(newVal) {
                // Actualizar `formData.roleId` según sea necesario
                this.formData.roleId = newVal.roleId || null;
            }
        }
    },

    methods: {

        ...mapActions({
            putActionActualizarUsersAdmin: `${USERSADMIN_M}${ACTION_PUT_UPDATE_USERSADMIN}`,
            getActionTypeIdentification: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_LIST_TYPE_DOCUMENT}`,
            getActionTypeRol: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_LIST_TYPE_ROL}`,
            getActionListCountry: `${PRODUCTS_M}${ACTION_GET_LIST_COUNTRY}`,
            getAffiliatedGender: `${USERSADMIN_M}${ACTION_GET_AFFILIATEDUSERS_LIST_GENDER}`,
            getActionUsersAdminId: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_ID}`,
        }),


        handleKeyDown(event) {
            // Permite solo números y la tecla de borrar
            if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },
        async updateUserAdmin() {
            this.formData.userId = this.usersAdmin,
                this.formData.firstName = this.usersAdminsUpdate.firstName,
                this.formData.middleName = this.usersAdminsUpdate.middleName,
                this.formData.lastName = this.usersAdminsUpdate.lastName,
                this.formData.isFirstUserCompany = false,
                this.formData.companyId = sessionStorage.getItem("idEmpresa"),
                this.formData.secondLastName = this.usersAdminsUpdate.secondLastName,
                this.formData.identificationType = this.usersAdminsUpdate.identification.identificationType,
                this.formData.emailAddress = this.usersAdminsUpdate.emailAddress,
                this.formData.genderId = this.usersAdminsUpdate.userDetailResponse.gender.genderId,
                this.formData.gernderName = this.usersAdminsUpdate.gernderName,
                this.formData.identificationId = this.usersAdminsUpdate.identification.identificationId,
                this.formData.cellPhoneNumber = this.usersAdminsUpdate?.userDetailResponse?.cellPhoneNumber,
                this.formData.roleId = this.usersAdminsUpdate.role.roleId,
                this.formData.nameRole = this.usersAdminsUpdate.role.nameRole,
                this.formData.identificationNumber = this.usersAdminsUpdate.identificationNumber,
                this.formData.countryPhoneCodeId = this.usersAdminsUpdate?.userDetailResponse.countryPhoneCode?.countryPhoneCodeId || null,
                this.formData.userDetailId = this.usersAdminsUpdate.userDetailResponse?.userDetailId

        },
        async submitForm() {
            try {
                const result = await Swal.fire({
                    title: i18n.t('label.confirm.title'),
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: i18n.t('button.save.text'),
                    cancelButtonText: i18n.t('button.cancel.text'),
                    confirmButtonColor: '#6E17A5'
                });

                if (result.isConfirmed) {
                    const validationErrors = this.validateForm();

                    if (Object.keys(validationErrors).length > 0) {
                        const errorMessages = Object.values(validationErrors).join('<br>');
                        Swal.fire({
                            icon: 'error',
                            title: i18n.t('label.errorsValidation.plural.title'),
                            html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
                            confirmButtonColor: '#6E17A5'
                        });
                        return;
                    }

                    const update = await this.putActionActualizarUsersAdmin(this.formData);
                    EventBus.$emit('reload-update-usersAdmin', update.nombre);

                    if (!update) {
                        return Swal.fire({
                            icon: 'error',
                            title: i18n.t('label.invalid.title'),
                            text: i18n.t('label.invalid.text')
                        });
                    }
                } else {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: i18n.t('label.delete.cancel'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                }
            } catch (error) {
                console.error(i18n.t('label.failService'), error);
            }
        },

        formatIdentificationNumber() {
            // Eliminar puntos y espacios del número de identificación actual
            let number = this.formData.identificationNumber.replace(/[^\d]/g, '');

            // Formatear el número con puntos de unidades, decenas, centenas, etc.
            let formattedNumber = '';
            while (number.length > 0) {
                // Agregar los últimos tres dígitos al principio del número formateado
                formattedNumber = number.slice(-3) + formattedNumber;

                // Quitar los últimos tres dígitos del número
                number = number.slice(0, -3);

                // Si todavía quedan dígitos, agregar un punto al principio del número formateado
                if (number.length > 0) {
                    formattedNumber = '.' + formattedNumber;
                }
            }

            // Asignar el número formateado de vuelta al campo de texto
            this.formData.identificationNumber = formattedNumber;
        },

        validateForm() {
            this.showErrorMessages = true;

            const errors = {};

            if (!this.formData.firstName || !this.formData.firstName.trim() || this.formData.firstName.length > 50) {
                errors.firstName = this.$t('usersAdmin.label.firstName.title');
            }

            if (this.formData.middleName && !/\S(?:.*\S)?/.test(this.formData.middleName)) {
                errors.middleName = this.$t('label.errorBlankSpace');
            }

            if (!this.formData.lastName || !this.formData.lastName.trim() || this.formData.lastName.length > 50) {
                errors.lastName = this.$t('usersAdmin.label.lastName.title');
            }

            if (this.formData.secondLastName && !/\S(?:.*\S)?/.test(this.formData.secondLastName)) {
                errors.secondLastName = this.$t('label.errorBlankSpace');
            }

            if (!this.formData.identificationType) {
                errors.identificationType = this.$t('label.typeIdentification.title');
            }

            if (!this.formData.emailAddress || !emailRegex.test(this.formData.emailAddress) || this.formData.emailAddress.length > 200) {
                errors.emailAddress = this.$t('label.email.title');
            }

            if (!this.formData.identificationNumber || !this.formData.identificationNumber.trim() || this.formData.identificationNumber.length > 19) {
                errors.identificationNumber = this.$t('label.numIdentification.title');
            }

            if (!this.formData.genderId) {
                errors.genderId = this.$t('usersAdmin.label.gender.title');
            }

            if (!this.formData.nameRole) {
                errors.nameRole = this.$t('usersAdmin.label.role.title');
            }

            if (!this.formData.countryPhoneCodeId) {
                errors.countryPhoneCodeId = this.$t('label.indicative.title');
            }

            if (!this.formData.cellPhoneNumber || !/^[0-9]{7,15}$/.test(this.formData.cellPhoneNumber)) {
                errors.cellPhoneNumber = this.$t('label.phone.title');
            }

            return errors;
        },
    },


};

</script>


<style lang="css" scoped>
/* Css input imagen*/

.col-md-7 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 230px;
}

.detailUsersAdmin {
    display: flex;
    gap: 50px;
    flex-direction: row;
    justify-content: center;
}

.custom-row {
    display: flex;
    gap: 50px;
    flex-direction: row;
    justify-content: center;
}

.custom-col {
    padding-left: 5px;
    padding-right: 5px;
}

/*Resposive*/
@media screen and (max-width: 912px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 820px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 768px) {
    .col-md-7 {
        gap: 40px;
    }

    .custom-row {
        display: flex;
        gap: 20px;
        flex-direction: column;
        justify-content: center;
    }
}

@media screen and (max-width: 425px) {
    .col-md-7 {
        gap: 10px;
        display: flex;
        flex-direction: column-reverse;
    }

    .custom-row {
        display: flex;
        gap: 50px;
        flex-direction: column;
        justify-content: center;
    }
}
</style>